module.exports = __webpack_public_path__ + "static/media/Group.e9a19356.png";